import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import KycContent from "../components/KycContent";

class IdentityVerification extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div className="row ml-0 pr-4 pl-4 mt-4">
              <div className="col-lg-12 grid-margin stretch-card">
                <KycContent />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default IdentityVerification;